import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import ReactSelect from 'react-select'
import { CATALOG_SORT, CATALOG_PAGE } from 'lib/core/resources/constants'
import { getSortOptions, getSortValue, LayeredNavMobile, useProductListPage } from 'lib/modules/catalog'
import { Pagination, PaginationStyles } from 'lib/shared'
import { Form, LateralMenu } from 'lib/ui'
import { Container, TotalCountContainer, SorterContainer, PaginationContainer, LayeredNavButton } from './styled'

interface Props {
  showTotalCount?: boolean
  showSorter?: boolean
  showPagination?: boolean
  categoryId?: number
  showLayeredNavAction?: boolean
  isDraft?: boolean
  isMulti?: boolean
  onChange?: () => void
}

export const LayeredControls = ({
  categoryId,
  showPagination = true,
  showSorter = true,
  showTotalCount = true,
  showLayeredNavAction = true,
  isDraft = true,
  isMulti = true,
  onChange
}: Props) => {
  const {
    isFetching,
    pageInfo,
    currentSort,
    sortOptions,
    totalCount,
    handleFilterChange
  } = useProductListPage({ categoryId })

  const intl = useIntl()
  const [layeredNavVisible, setLayeredNavVisible] = useState(false)
  const renderPagination = ((pageInfo?.totalItems ?? 0) > (pageInfo?.pageSize ?? 0))
  const options = getSortOptions(sortOptions)

  function handleSortChange (e: any) {
    handleFilterChange({
      requestVar: CATALOG_SORT.SORT_BY,
      value: e.value
    })
    onChange?.()
  }

  function handlePageChange (e: number) {
    handleFilterChange({
      requestVar: CATALOG_PAGE.PAGE,
      value: [e.toString()]
    })
    onChange?.()
  }

  return (
    <Container
      isFetching={isFetching}
    >
      <div>
        {!!totalCount && (
          <>
            {showLayeredNavAction && (
              <LayeredNavButton>
                <button
                  type='button'
                  onClick={() => setLayeredNavVisible(true)}
                >
                  {intl.formatMessage({ id: 'catalog.productList.action.viewFilters' })}
                </button>
              </LayeredNavButton>
            )}

            {showTotalCount && (
              <TotalCountContainer>
                {intl.formatMessage({ id: 'catalog.productList.totalCount' }, { totalCount })}
              </TotalCountContainer>
            )}

            {showSorter && (
              <SorterContainer>
                <Form.ReactSelectTheme.Wrapper>
                  <ReactSelect
                    value={getSortValue(currentSort, options)}
                    classNamePrefix={Form.ReactSelectTheme.classNamePrefix}
                    options={options}
                    onChange={handleSortChange}
                  />
                </Form.ReactSelectTheme.Wrapper>
              </SorterContainer>
            )}

            {showPagination && renderPagination && (
              <PaginationContainer>
                <PaginationStyles>
                  {pageInfo && (
                    <Pagination
                      currentPage={pageInfo.currentPage}
                      pageSize={pageInfo.pageSize}
                      totalItems={pageInfo.totalItems}
                      onChange={handlePageChange}
                    />
                  )}
                </PaginationStyles>
              </PaginationContainer>
            )}
          </>
        )}
      </div>

      <LateralMenu
        isVisible={layeredNavVisible}
        onOverlayClick={() => setLayeredNavVisible(false)}
      >
        <LayeredNavMobile
          isDraft={isDraft}
          isMulti={isMulti}
          categoryId={categoryId}
          onApplyFilters={() => {
            setLayeredNavVisible(false)
            if (onChange) {
              setTimeout(onChange, 500)
            }
          }}
        />
      </LateralMenu>
    </Container>
  )
}
